import * as yup from 'yup'

export const validateCreateEventSpeaker = yup.object().shape({
    name: yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El Nombre debe tener más de 1 caracteres'),
    priority: yup
    .number()
})